import { Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const ManageRosterPageHeader = ({ title }) => {
  const navigate = useNavigate();

  const handleBack = (e) => {
    e.preventDefault();
    navigate("/selectRoster", { replace: true });
  };

  return (
    <>
      <Row>
        <Col>
          <h3 className="font-weight-bold">{title}</h3>
        </Col>
        <Col className="d-flex justify-content-end" xs={2}>
          <Button variant="secondary" onClick={handleBack}>
            Go Back
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <hr />
        </Col>
      </Row>
    </>
  );
};

export default ManageRosterPageHeader;
